<div class="loader-1__container">
  <ng-lottie 
    class="loader-1__animation"
    [options]="options"
  />
  
  <p class="loader-1__text ci-paragraph-p1-regular">
    {{ 'Cargando' | translate }}...
  </p>
</div>

